var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#777",
    fillRule: "evenodd",
    d: "M1 13.519c-.368-.246-.443-.71-.167-1.038L5.458 7 .833 1.519C.557 1.19.632.727 1 .482c.368-.246.89-.18 1.167.148l5 5.926a.676.676 0 0 1 0 .888l-5 5.926c-.276.328-.799.394-1.167.149",
    clipRule: "evenodd"
  })));
};
export default SvgArrow;